import { IUserSummary } from '../types';

export const issueLabel = (
  id: number,
  creator?: IUserSummary | null,
) => `Pendência #${id}${creator ? ` (${creator.display_name})` : ''}`;
